import Axios, { AxiosPromise, AxiosResponse } from 'axios';
import VueRouter from 'vue-router';

export default class TMAuth {
  /**
   * String that will be utilized to get the token from localStorage
   *
   * @example if set to 'timoApiTtoken' the token will accessed using licaltorage.getItem('timoApiToken')
   */
  private static tokenIdentifier: string = 'nortox-api-token';

  // private static baseUrl: string = 'http://2019.fanaticosnortox.com.br/api/v1';

  public static isAuthenticated(): boolean {
    const token: string | null = localStorage.getItem(TMAuth.tokenIdentifier);

    return token !== null;
  }

  public static logout(router: VueRouter): void {
    localStorage.removeItem('nortox-api-token');
    if (router.currentRoute.name !== 'Login') {
      router.push('/login');
    }
  }
}
